import React from 'react';
import { Button } from '@chakra-ui/react';

const HIT_AREA_SX = {
  // Padding + border are part of the clickable surface.
  // Prevent icons/labels from becoming the only hit target.
  '& > *': { pointerEvents: 'none' },
};

/** Primary CTA — blue on Logo Brand, amber on Classic. */
export function PrimaryButton({ children, sx, ...props }) {
  return (
    <Button variant="primary" sx={{ ...HIT_AREA_SX, ...sx }} {...props}>
      {children}
    </Button>
  );
}

/** Secondary CTA — tangerine from logo warm side (Classic falls back to amber). */
export function SecondaryButton({ children, sx, ...props }) {
  return (
    <Button variant="secondary" sx={{ ...HIT_AREA_SX, ...sx }} {...props}>
      {children}
    </Button>
  );
}

export function OutlineButton({ children, sx, ...props }) {
  return (
    <Button variant="outlineInk" sx={{ ...HIT_AREA_SX, ...sx }} {...props}>
      {children}
    </Button>
  );
}

export function DangerButton({ children, sx, ...props }) {
  return (
    <Button variant="danger" sx={{ ...HIT_AREA_SX, ...sx }} {...props}>
      {children}
    </Button>
  );
}
